import React from 'react';
import PropTypes from 'prop-types';
import xdk from '@accedo/xdk-core';
import classNames from 'classnames';
import { FaCookieBite } from 'react-icons/fa';

import { showConsentPreferences } from '#/services/consent/consent';
import styles from './CookiePreferencesLink.scss';

export const shouldShowCookiePreferencesLink = platform =>
  platform === 'workstation';

const CookiePreferencesLink = ({ parentZone = false }) => {
  if (!shouldShowCookiePreferencesLink(xdk.platform)) {
    return null;
  }

  return (
    <button
      type="button"
      className={classNames(styles.cookiePreferencesLink, {
        [styles.parentZone]: parentZone,
      })}
      onClick={showConsentPreferences}
      aria-label="Change cookie choices"
      title="Change cookie choices"
      data-cookie-preferences-placement={parentZone ? 'parent-zone' : 'global'}
    >
      <FaCookieBite aria-hidden="true" focusable="false" />
      <span>Cookie choices</span>
    </button>
  );
};

CookiePreferencesLink.propTypes = {
  parentZone: PropTypes.bool,
};

export default CookiePreferencesLink;
